import { css } from '@emotion/react';
import { Box, Text, Title } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

import { LANDING_COLOR, LANDING_FONT, LANDING_MOBILE_MQ, LANDING_SPACE } from './constants';

const FAQ_ITEMS = [
  {
    qKey: 'ai_interviews.landing.faq.usage.q',
    qDefault: '이용 가격과 횟수는 어떻게 되나요?',
    aKey: 'ai_interviews.landing.faq.usage.a',
    aDefault: 'ID당 1회 무료로 이용할 수 있어요. 다회 이용은 곧 제공될 예정이에요.',
  },
  {
    qKey: 'ai_interviews.landing.faq.resume.q',
    qDefault: '중간에 나갔다가 다시 할 수 있나요?',
    aKey: 'ai_interviews.landing.faq.resume.a',
    aDefault: '네, 다시 들어오면 진행하던 단계부터 이어서 할 수 있어요.',
  },
  {
    qKey: 'ai_interviews.landing.faq.report.q',
    qDefault: '결과 리포트는 어디서 보나요?',
    aKey: 'ai_interviews.landing.faq.report.a',
    aDefault:
      '면접이 끝나고 리포트가 완성되면 카카오톡으로 알려드려요. 이 페이지의 "내 결과 보고서 보기"로 언제든 다시 볼 수 있어요.',
  },
  {
    qKey: 'ai_interviews.landing.faq.privacy.q',
    qDefault: '개인정보는 어떻게 처리되나요?',
    aKey: 'ai_interviews.landing.faq.privacy.a',
    // 임시 문구 — 법무 확정본으로 교체 필요
    aDefault: '업로드한 파일과 영상·음성은 면접 질문 생성·분석에만 사용되며 안전하게 처리돼요.',
  },
] as const;

export const Faq = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      id="faq"
      css={styles.section}
      data-reveal
      aria-labelledby="ai-faq-title"
    >
      <Box css={styles.inner}>
        <Title order={3} id="ai-faq-title" css={styles.title}>
          {t('ai_interviews.landing.faq.title', '자주 묻는 질문')}
        </Title>

        <Box css={styles.list}>
          {FAQ_ITEMS.map((item, index) => (
            <Box
              key={item.qKey}
              css={[styles.row, index === FAQ_ITEMS.length - 1 ? styles.rowLast : null]}
            >
              <Text css={styles.question}>{t(item.qKey, item.qDefault)}</Text>
              <Text css={styles.answer}>{t(item.aKey, item.aDefault)}</Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  section: css({
    background: '#fff',
    padding: `${LANDING_SPACE.sectionTop} ${LANDING_SPACE.pageX} ${LANDING_SPACE.sectionBottomLg}`,
  }),
  inner: css({
    maxWidth: 960,
    margin: '0 auto',
  }),
  title: css({
    margin: `0 0 ${LANDING_SPACE.titleBottom}`,
    fontSize: LANDING_FONT.sectionTitleSm,
    fontWeight: 800,
    letterSpacing: '-0.03em',
    color: LANDING_COLOR.ink,
    wordBreak: 'keep-all',
  }),
  list: css({}),
  row: css({
    display: 'grid',
    gridTemplateColumns: 'minmax(140px, 300px) 1fr',
    gap: LANDING_SPACE.rowGap,
    padding: `${LANDING_SPACE.rowY} 0`,
    borderTop: '1px solid rgba(17,19,21,.1)',
    [LANDING_MOBILE_MQ]: {
      gridTemplateColumns: '1fr',
    },
  }),
  rowLast: css({
    borderBottom: '1px solid rgba(17,19,21,.1)',
  }),
  question: css({
    fontSize: LANDING_FONT.body,
    fontWeight: 600,
    color: LANDING_COLOR.ink,
    lineHeight: 1.5,
    wordBreak: 'keep-all',
  }),
  answer: css({
    fontSize: LANDING_FONT.body,
    lineHeight: 1.75,
    color: LANDING_COLOR.bodyMuted,
    textWrap: 'pretty',
    wordBreak: 'keep-all',
  }),
};
